import { BannerImage } from '@app/mdxsource'
import React from 'react'
import anylogger from '@app/anylogger'

const log = anylogger('BannerImageView')

interface BannerImageProps {
	bannerImage?: BannerImage
	transitionParams?: string
	height?: number
}
const BannerImageView = React.forwardRef(function BannerImage(props: BannerImageProps, ref: any) {
	const { bannerImage, height, transitionParams = '0.3s ease' } = props
	if (!bannerImage?.src) return null
	const minHeight = typeof height != 'undefined' ? `${height}px` : '200px'
	const position = bannerImage?.position || 'top'

	return (
		<div
			style={{
				padding: '0',
				minHeight: minHeight,
				width: '100%',
				background: `url(${encodeURI(bannerImage.src)})  ${position} /cover`,
				transition: `min-height ${transitionParams}`,
				overflow: 'hidden',
				position: 'relative'
			}}
		></div>
	)
})
export default BannerImageView
